export {default as AddC} from 'modules/reservas/components/add';
export {default as ReservasPendientesC} from 'modules/reservas/components/reservaPendiente';



// WEBPACK FOOTER //
// src/modules/reservas/component.js